<template>
  <!--单项选择题-->
  <div @click="setEditIndex(index)">
    <el-row :gutter="10" style="margin-left: 5px">
      <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
        {{ number }}
      </el-col>
      <el-col
        :xs="15"
        :sm="15"
        :md="15"
        :lg="15"
        :xl="15"
        class="item_container_title"
      >
        <contenteditable-div
          class="title-input"
          :key="question.id"
          @focus="showAdvance"
          @blur="updateQuestion()"
          v-model="question.questionsName"
          >{{ question.questionsName }}</contenteditable-div
        >
        <div v-if="question.optionRelationTips != ''" style="color: #ccc">
          {{ question.optionRelationTips }}
        </div>
      </el-col>
      <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
        <i
          class="el-icon-delete delete"
          v-if="index == editIndex"
          @click="questiondel(question.id)"
        ></i>
        <el-badge
          v-if="question.displayscriptcount || question.jumpscriptcount"
          :value="question.displayscriptcount + question.jumpscriptcount"
          class="item"
        >
          <i
            class="el-icon-share"
            @click="() => $emit('jumpshow', question.id)"
          ></i>
        </el-badge>
        <i class="el-icon-rank item drag-handle"></i>
      </el-col>
    </el-row>

    <div>
      <div v-if="!!question.ifGrouping">
        <!-- 分组 -->
        <el-row
          style="margin-top: 12px"
          v-for="childItem in question.groupingOptionList"
          :key="childItem.id"
        >
          <p style="font-size: 14px; margin-left: 50px">
            {{ childItem.groupName }}
          </p>
          <el-row class="elcol-option">
            <template v-if="childItem.questionsOptionVOS">
              <draggable
                class="drag-container"
                v-bind="dragOptions"
                v-model="childItem.questionsOptionVOS"
                @start="drag_start"
                @end="drag_end"
              >
                <transition-group
                  tag="div"
                  type="transition"
                  :name="!drag ? 'flip-list' : null"
                >
                  <el-col
                    v-for="(
                      option, optionindex
                    ) in childItem.questionsOptionVOS"
                    :key="option.id"
                    :span="24 / question.choiceLayout"
                  >
                    <div class="option" @click="setEditOptionIndex(option.id)">
                      <div class="option-icon"></div>
                      <contenteditable-div
                        class="div-input"
                        :class="{ 'fill-empty': !!option.ifFillEmpty }"
                        @focus="showAdvance"
                        @blur="wjupdoption(option)"
                        v-model="option.labelName"
                        >{{ option.labelName }}</contenteditable-div
                      >
                      <div
                        class="control"
                        :style="{
                          visibility:
                            editOptionIndex == option.id && editIndex == index
                              ? 'visible'
                              : 'hidden',
                        }"
                      >
                        <i
                          class="el-icon-s-tools el-icon-common-option"
                          @click.stop="
                            wjsetquestionoption(
                              question,
                              question.optionList,
                              option,
                              optionindex
                            )
                          "
                        ></i>
                        <i
                          class="el-icon-remove el-icon-common-option"
                          @click.stop="
                            wjdelquestionoption(
                              question.optionList,
                              option,
                              optionindex
                            )
                          "
                        ></i>
                      </div>
                    </div>
                  </el-col>
                </transition-group>
              </draggable>
            </template>
          </el-row>
        </el-row>
        <span class="clear"></span>
      </div>
      <div v-else>
        <!-- 默认 -->

        <el-row class="elcol-option">
          <draggable
            class="drag-container"
            v-bind="dragOptions"
            v-model="question.optionList"
            @start="drag_start"
            @end="drag_end"
          >
            <transition-group
              tag="div"
              type="transition"
              :name="!drag ? 'flip-list' : null"
            >
              <el-col
                v-for="(option, optionindex) in question.optionList"
                :key="option.id"
                :span="24 / question.choiceLayout"
              >
                <div class="option" @click="setEditOptionIndex(option.id)">
                  <div class="option-icon"></div>
                  <contenteditable-div
                    class="div-input"
                    :class="{ 'fill-empty': !!option.ifFillEmpty }"
                    @focus="showAdvance"
                    @blur="wjupdoption(option)"
                    v-model="option.labelName"
                    >{{ option.labelName }}</contenteditable-div
                  >
                  <div
                    class="control"
                    :style="{
                      visibility:
                        editOptionIndex == option.id && editIndex == index
                          ? 'visible'
                          : 'hidden',
                    }"
                  >
                    <i
                      class="el-icon-s-tools el-icon-common-option"
                      @click.stop="
                        wjsetquestionoption(
                          question,
                          question.optionList,
                          option,
                          optionindex
                        )
                      "
                    ></i>
                    <i
                      class="el-icon-remove el-icon-common-option"
                      @click.stop="
                        wjdelquestionoption(
                          question.optionList,
                          option,
                          optionindex
                        )
                      "
                    ></i>
                  </div>
                </div>
              </el-col>
            </transition-group>
          </draggable>
        </el-row>

        <span class="clear"></span>
      </div>
    </div>

    <el-row
      :gutter="10"
      style="margin-top: 12px !important"
      v-if="index == editIndex"
    >
      <el-col
        :xs="16"
        :sm="16"
        :md="16"
        :lg="16"
        :xl="16"
        class="el_item_option item_container_title"
        style="margin-left: 50px"
      >
        <i
          class="el-icon-plus el-icon-common"
          @click="wjaddquestionoption(question.optionList, question, 0)"
          >添加选项</i
        >
        <i
          class="el-icon-s-fold el-icon-common"
          @click="batchAdd(question.optionList, question)"
          >批量添加</i
        >
        <i
          class="el-icon-menu el-icon-common"
          @click="wjaddquestionoption(question.optionList, question, 1)"
          >添加【其他】</i
        >
      </el-col>
    </el-row>
  </div>
</template>
<script>
import DragMixin from "./DragMixin";
export default {
  mixins: [DragMixin],
  data() {
    return {
      editOptionIndex: "0",
      set: "set",
    };
  },
  props: {
    number: { type: Number, default: 0 },
    question: {},
    editIndex: { type: Number, default: 0 },
    isExistPage: { type: Boolean, default: false },
    index: { type: Number, default: 0 },
  },
  computed: {
    span() {
      var _span = { 1: 24, 2: 12, 3: 8 };
      return _span[question.choiceLayout];
    },
  },
  methods: {
    batchAdd(options, item) {
      this.$emit("batchAdd", options, item);
    },
    wjsetquestionoption(
      questionsSonList,
      options,
      item,
      childindex,
      childItem
    ) {
      this.$emit("wjsetquestionoption", options, item, childindex, childItem);
      this.$emit(
        "setrect",
        questionsSonList,
        options,
        item,
        childindex,
        this.set,
        this.question.id
      );
    },
    wjupdoption(item) {
      this.$emit("wjupdoption", item);
    },
    updateQuestion() {
      this.$emit("wjupdquestionoption", this.question);
    },
    wjaddquestionoption(optionList, item, type = 1) {
      this.$emit("wjaddquestionoption", optionList, item, type);
    },
    showAdvance(e) {
      this.$emit("showAdvance", e);
    },
    setEditIndex(index) {
      this.$emit("setEditIndex", index);
    },
    setEditOptionIndex(childIndex) {
      this.editOptionIndex = childIndex;
    },
    wjdelquestionoption(options, item, childindex) {
      this.$emit("wjdelquestionoption", options, item, childindex);
    },
    questiondel(id) {
      this.$emit("questiondel", id);
    },
  },
  created() {
    // console.log('question对象',this.question)
  },
};
</script>

<style scoped>
/deep/.el-input {
  width: 61% !important;
}
.inputStyle {
  border: 1px solid #cccccc !important;
  width: 50px;
  height: 25px;
}
/*输入框input*/
/deep/.two_lines .el-input__inner {
  width: 80px !important;
}
.delete,
.item {
  font-size: 22px !important;
  line-height: 40px !important;
  margin-right: 30px !important;
  text-align: right;
  float: right;
  cursor: pointer;
}
.item .el-badge__content.is-fixed {
  top: 10px;
}
.item.drag-handle {
  cursor: move;
}
.el_item_option {
  line-height: 40px;
  height: 44px;
}

.el-icon-common {
  margin-right: 23px;
  font-size: 16px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.el-icon-common-option {
  margin-left: 10px;
  font-size: 22px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.askxh {
  line-height: 40px;
  text-align: right;
}

.item_container_title {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

/* .item_container_title:hover {
border: 1px darkgrey dashed; 
} */
.title-input {
  display: inline-block;
  width: 100%;
  line-height: 40px;
  color: #606266;
  font: 400 13.3333px Arial;
  padding: 10px 15px 0 15px;
}

.elcol-option {
  padding: 0 70px;
}
/* 选项 */
.option {
  display: flex;
  min-height: 44px;
  line-height: 44px;
}
/* 选项icon */
.option .option-icon {
  vertical-align: middle;
}
.option .option-icon::after {
  content: "";
  display: inline-block;
  border: 1px solid #dcdfe6;
  border-radius: 100%;
  width: 14px;
  height: 14px;
  background-color: #fff;
  cursor: pointer;
  box-sizing: border-box;
}
/* 选项输入 */
.option .div-input {
  flex: 1;
  margin: 0 25px;
  width: 0;
  font-size: 14px;
  font-family: Arial;
  color: #606266;
}
/* 选项操作 */
.option .control {
  width: 80px;
}
.option .fill-empty::after {
  content: "XXXXXXXXX";
  display: inline;
  margin-left: 20px;
  width: 100px;
  height: 18px;
  border: 1px solid #adaeaf;
  border-radius: 2px;
  background-color: #fff;
  color: rgba(0, 0, 0, 0);
  overflow-wrap: normal;
  word-break: keep-all;
}
.clear {
  display: block;
  height: 1px;
  width: 1px;
  clear: both;
}
</style>
